import { IPrismicPrivateLabelCTA, IPrivateLabelCTA } from './types';

export const mapPrivateLabelCTA = ({
  prismicContent,
}: {
  prismicContent: IPrismicPrivateLabelCTA;
}): IPrivateLabelCTA => {
  const { title, img, caption } = prismicContent.primary;

  const privateLabelCTA: IPrivateLabelCTA = {
    title,
    img,
    caption,
    items: prismicContent.items,
  };

  return privateLabelCTA;
};
